import { Injectable } from '@angular/core';
import {IEntityApi} from '../../interfaces/entity-api.interface';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {UrlService} from './url.service';
import {ResponseService} from './response.service';
import {RequestConfig} from '../../configs/request.config';
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DeletedUserService {
  constructor(private _http: HttpClient,
              private _router: Router,
              private _urlService: UrlService,
              private _responseService: ResponseService) { }

  index(body: any) {
    return this._http.post(this._urlService.getDeletedUsers(), body, RequestConfig.options)
      .pipe(map(res => {
          const error = this._responseService.parseError(res);
          if (error) throw new Error(error);


          return this._responseService.parseResponse(res);
        }),
        catchError(err => {
          console.log(err);
          this._responseService.parseUnhandledError(err);
          throw err;
        }),);
  }
}
